<template>
    <div class="carousel wrap clearfix" v-if="list.length">
        <h4>Recent bekeken</h4>
        <carousel :scrollPerPage="true" :paginationColor="'#cacac8'" :perPageCustom="[[1, 1], [465, 2], [768, 3], [1024, 4]]">
            <slide v-for="item in list" :key="item.id">
                <stock-item
                    :merk="item.merk"
                    :model="item.model"
                    :type="item.type"
                    :slug="item.slug"
                    :image="item.image"
                    :image2="item.image2"
                    :price="item.verkoopprijs_particulier"
                    :translations="translations"
                    :key="item.id">
                </stock-item>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel'
    // import axios from 'axios'

    const api = '/get/recent'

    let stockItem = {
        props: {
            'merk': String,
            'type': String,
            'model': String,
            'image': String,
            'image2': String,
            'price': String,
            'slug': String,
            'translations': {},
        },
        template: `<div class="uk-height-1-1">
        <div class="stockitem uk-height-1-1">
          <div class="overlay">
            <div class="buttons">
              <a class="button blue" :href="'/truck/'+slug" :title="'meer info over: ' + merk + ' ' + type + ' ' + model">{{ translations.meer_info }}</a>
            </div>
          </div>
          <div class="image" :style="{ backgroundImage: 'url(' + image + ')' }"></div>
          <div class="content">
            <div class="large"> {{ merk }} {{ model }} {{ type }} </div>
            <span class="large price" v-if="price > 0">&euro; {{ price | number }},-</span>
            <span class="large price" v-else>{{ translations.Prijs_op_aanvraag }}</span>
          </div>
        </div>
      </div>
    `,
    }

    export default {
        data () {
            return {
                currentId: this.$root.current_id,
                translations: {},
                ids: [],
                list: '',
            }
        },
        mounted: function () {
            this.setCurrent()
            this.translations = this.$root.translations
        },
        methods: {
            setCurrent () {
                let
                    rv = this.$ls.get('recentViewed'),
                    currentId = this.currentId

                // console.log(rv)

                if (rv) {
                    let rva = rv;
                    (rva.indexOf(currentId) === -1) && rva.push(currentId)
                    this.ids = rva
                } else {
                    this.ids.push(currentId)
                }

                this.$ls.set('recentViewed', this.ids, this.getViewed())
            },
            getViewed () {
                let $$ = this
                this.$axios.get(api + '?current=' + this.currentId + '&ids=' + this.ids).then(response => {
                    $$.list = response.data
                    if ($$.list.length) {
                        this.setCarousel()
                    }
                }).catch(error => {
//              console.log(error);
                })
            },
        },
        components: {
            Carousel,
            Slide,
            stockItem,
        },
    }
</script>